import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_Details } from '../constants';


interface IProps {
  title: string;
  description: string;
  type: string;
//   name: string;
}
const SEO = ({ title, description, type }: IProps) => {
  useEffect(() => {
  //  console.log('title', window.location.href);
  }, [title])
  
  return (
    <Helmet>
      <title data-rh="true">{title}</title>
      <meta name="description" content={description} data-rh="true"/>
      <link rel="canonical" href={SEO_Details.websiteUrl} />
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content='https://modelcentral.ai/89ebfa018e1fee8a521a.png'/>
      { /* Twitter tags */ }
        <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      { /* End Twitter tags */ }
    </Helmet>
  );
};

export default SEO;
